import {Injectable} from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class BrowserWindowService {
    private _initialUrl: string;

    public constructor() {
        window.onpopstate = (): void => {
            this.reloadPage();
        };
    }

    public getQueryString(): string {
        const queryString: string = window.location.search;

        if (queryString && (queryString.length > 1)) {
            return queryString.slice(1);
        }

        return null;
    }

    public setQueryString(queryString: string): void {
        const currentUrl = window.location;
        const updatedUrl = [currentUrl.protocol, "//", currentUrl.host, currentUrl.pathname, queryString.length ? "?" : "", queryString].join("");

        if (currentUrl.href !== updatedUrl) {
            if (!this._initialUrl) {
                this._initialUrl = updatedUrl;
                window.history.replaceState({}, "", updatedUrl);
            } else {
                window.history.pushState({}, "", updatedUrl);
            }
        }
    }

    public reloadPage(): void {
        window.location.reload();
    }
}
